import { Endpoints } from "@brg/api";
import {SimpleTitle} from "../styles";
import React, {FC, Fragment, useMemo} from "react";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { serviceToLinkMapper } from "shared/constants/notifyService2LinkMapper";
import { useProfile } from "@brg/auth";

const escapeRegExp = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Тип действия по клику на текст (ничего не делать / открыть ссылку / скачать файл)
 */
export enum NotificationActionType {
    NONE="none",
    OPEN_PAGE="openPage",
    DOWNLOAD_FILE="downloadFile"
}

enum NotificationActionEntityType {
    CALENDAR="calendar",
    CALENDAR_PDF="calendarpdf",
    CARD="card",
    POSTER="poster",
    CARD_PDF="cardpdf",
    PAGE_LINK="pageLink",
    GENERATION="generation",
    PROJECT="project"
}

interface NotificationPart {
    text: string
    link?: string
    entityId?: string
    type: NotificationActionType
    entityType?: NotificationActionEntityType
}

 const getLinkByEntityType = (origin: string, accountId: string | undefined, actionPart: NotificationPart) => {
    switch (actionPart.entityType) {
        case NotificationActionEntityType.CALENDAR:
            return `${origin}/365/calendar/preview/${actionPart.entityId}`
        case NotificationActionEntityType.CALENDAR_PDF:
            return `${origin}/card/${actionPart.entityId}`
        case NotificationActionEntityType.CARD:
            return `${origin}/card/${actionPart.entityId}`
        case NotificationActionEntityType.POSTER:
            return `${origin}${actionPart.link}`
        case NotificationActionEntityType.CARD_PDF:
            return `${origin}/card/${actionPart.entityId}`
        case NotificationActionEntityType.PAGE_LINK:
            return actionPart.link
        case NotificationActionEntityType.GENERATION:
            return `${origin}/generate/${accountId}?gen=${actionPart.entityId}`
        case NotificationActionEntityType.PROJECT:
            return `${origin}/project/${actionPart.entityId}`
        default:
            return ''
    }
 }

export const NotificationWithAction: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const { error, info } = useToasts()
    const { t } = useTranslation()
    const profile = useProfile()

    const [ notificationData ] = actions;
    const { description, entityName } = notificationData;
    const textParts: any[] = notificationData.textParts;
    const service = actions[0]?.service;
   
    const dividedNotification: NotificationPart[] = useMemo(() => {
        const actionParts = new Map<string, NotificationPart>()

        textParts.forEach((part: any) => {
            part?.parts?.forEach((partObj: any) => {
                const partText = partObj && Object.values(partObj).join("")
                actionParts.set(partText, {
                    text: partText,
                    link: part?.link,
                    entityId: part?.entityId,
                    entityType: part?.entityType,
                    type: part?.linkType
                })
            })
        })

        if (actionParts.size < 1) return []
        
        let newDesc: string = description
        
        if (!newDesc) return []

        const actionPartKeys: string[] = Array.from(actionParts.keys() as any)

        const regex = new RegExp(`(${actionPartKeys.map(escapeRegExp).join('|')})`, 'g');

        return newDesc.split(regex).filter(part => part).map(part => {
            if (actionParts.has(part)) {
                return actionParts.get(part)!
            }
            return {
                text: part,
                type: NotificationActionType.NONE
            }
        })
    }, [description, textParts]) 

    const handleDownload = (uploadUrl: string) => {
        info(t('print_project_save'))
        fetch(uploadUrl, { method: 'GET' })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${entityName}.pdf`
                document.body.appendChild(a);
                a.click();
                //@ts-ignore
                a = undefined
            })
            .catch((err: any) => {
                console.log('print_error_message', err)
                error(t('print_error_message'))
            })
    }

    return <SimpleTitle>
        {dividedNotification.map((part, idx) => {
            if (part.type === NotificationActionType.NONE) return <Fragment key={idx}>{part.text}</Fragment>
            if (part.type === NotificationActionType.OPEN_PAGE) {
                const origin = serviceToLinkMapper[service]?.origin ?? window.location.origin
                const link = getLinkByEntityType(origin, profile?.accountId, part)
                return <a href={link} target="_blank" rel="noreferrer" key={idx}>{part.text}</a>
            }
            if (part.type === NotificationActionType.DOWNLOAD_FILE) {
                // const uploadUrl = `${Endpoints.files}/${part?.link}`
                return <a key={idx}>{part.text}</a>
            }
        })}
    </SimpleTitle>
}import { Endpoints } from "@brg/api";
import {SimpleTitle} from "../styles";
import React, {FC, Fragment, useMemo} from "react";
import { useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { serviceToLinkMapper } from "shared/constants/notifyService2LinkMapper";
import { useProfile } from "@brg/auth";

const escapeRegExp = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Тип действия по клику на текст (ничего не делать / открыть ссылку / скачать файл)
 */
export enum NotificationActionType {
    NONE="none",
    OPEN_PAGE="openPage",
    DOWNLOAD_FILE="downloadFile"
}

enum NotificationActionEntityType {
    CALENDAR="calendar",
    CALENDAR_PDF="calendarpdf",
    CARD="card",
    POSTER="poster",
    CARD_PDF="cardpdf",
    PAGE_LINK="pageLink",
    GENERATION="generation",
    PROJECT="project"
}

interface NotificationPart {
    text: string
    link?: string
    entityId?: string
    type: NotificationActionType
    entityType?: NotificationActionEntityType
}

 const getLinkByEntityType = (origin: string, accountId: string | undefined, actionPart: NotificationPart) => {
    switch (actionPart.entityType) {
        case NotificationActionEntityType.CALENDAR:
            return `${origin}/365/calendar/preview/${actionPart.entityId}`
        case NotificationActionEntityType.CALENDAR_PDF:
            return `${origin}/card/${actionPart.entityId}`
        case NotificationActionEntityType.CARD:
            return `${origin}/card/${actionPart.entityId}`
        case NotificationActionEntityType.POSTER:
            return `${origin}${actionPart.link}`
        case NotificationActionEntityType.CARD_PDF:
            return `${origin}/card/${actionPart.entityId}`
        case NotificationActionEntityType.PAGE_LINK:
            return actionPart.link
        case NotificationActionEntityType.GENERATION:
            return `${origin}/generate/${accountId}?gen=${actionPart.entityId}`
        case NotificationActionEntityType.PROJECT:
            return `${origin}/project/${actionPart.entityId}`
        default:
            return ''
    }
 }

export const NotificationWithAction: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const { error, info } = useToasts()
    const { t } = useTranslation()
    const profile = useProfile()

    const [ notificationData ] = actions;
    const { description, entityName } = notificationData;
    const textParts: any[] = notificationData.textParts;
    const service = actions[0]?.service;
   
    const dividedNotification: NotificationPart[] = useMemo(() => {
        const actionParts = new Map<string, NotificationPart>()

        textParts.forEach((part: any) => {
            part?.parts?.forEach((partObj: any) => {
                const partText = partObj && Object.values(partObj).join("")
                actionParts.set(partText, {
                    text: partText,
                    link: part?.link,
                    entityId: part?.entityId,
                    entityType: part?.entityType,
                    type: part?.linkType
                })
            })
        })

        if (actionParts.size < 1) return []
        
        let newDesc: string = description
        
        if (!newDesc) return []

        const actionPartKeys: string[] = Array.from(actionParts.keys() as any)

        const regex = new RegExp(`(${actionPartKeys.map(escapeRegExp).join('|')})`, 'g');

        return newDesc.split(regex).filter(part => part).map(part => {
            if (actionParts.has(part)) {
                return actionParts.get(part)!
            }
            return {
                text: part,
                type: NotificationActionType.NONE
            }
        })
    }, [description, textParts]) 

    const handleDownload = (uploadUrl: string) => {
        info(t('print_project_save'))
        fetch(uploadUrl, { method: 'GET' })
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `${entityName}.pdf`
                document.body.appendChild(a);
                a.click();
                //@ts-ignore
                a = undefined
            })
            .catch((err: any) => {
                console.log('print_error_message', err)
                error(t('print_error_message'))
            })
    }

    return <SimpleTitle>
        {dividedNotification.map((part, idx) => {
            if (part.type === NotificationActionType.NONE) return <Fragment key={idx}>{part.text}</Fragment>
            if (part.type === NotificationActionType.OPEN_PAGE) {
                const origin = serviceToLinkMapper[service]?.origin ?? window.location.origin
                const link = getLinkByEntityType(origin, profile?.accountId, part)
                return <a href={link} target="_blank" rel="noreferrer" key={idx}>{part.text}</a>
            }
            if (part.type === NotificationActionType.DOWNLOAD_FILE) {
                // const uploadUrl = `${Endpoints.files}/${part?.link}`
                return <a key={idx}>{part.text}</a>
            }
        })}
    </SimpleTitle>
}